module.exports = __webpack_public_path__ + "static/img/liveControl-bg4.bd3cc5cf.png";